module.exports = __webpack_public_path__ + "static/media/namibian.e0cbe26f.jpg";